import { FC, ReactNode } from 'react';
import { Section, Link } from 'components';
import VisualA from 'assets/images/agro-visual-a.svg';
import VisualB from 'assets/images/agro-visual-b.svg';

import S from './AgroBenefitsSection.Styled';

interface BenefitProps {
  image: string;
  alt: string;
  width: number;
  text: ReactNode;
}

const benefits: BenefitProps[] = [
  {
    image: VisualA,
    alt: 'Mentoring using computer',
    width: 310,
    text: (
      <>
        <b>Eπιμόρφωση (training) & Βιωματική Μάθηση</b>, από καθηγητές της Αμερικανικής Γεωργικής Σχολής και του Alba
        Graduate Business School, The American College of Greece, συνολικής διάρκειας 12-14 ωρών.
        <br />
        <br />
        Οι θεματικές που θα καλυφθούν αφορούν στην ψηφιοποίηση του αγρού, θέματα επιχειρηματικότητας και τη μετάβαση
        προς στην πράσινη γεωργία.
        <br />
        <br />
        Επιπλέον, θα διεξαχθεί και τομεακή επιμόρφωση, με θεματολογία ανάλογα με τα ενδιαφέροντα και τον τομέα
        δραστηριότητας των συμμετεχουσών (4-6 ώρες).
        <br />
        <br />
        Στα πλαίσια της επιμόρφωσης, θα πραγματοποιηθούν επίσης <b>ζωντανές συνεδρίες (βιωματική μάθηση)</b> με
        αγρότισσες/αγρότες που θα παρουσιάσουν <b>βέλτιστες πρακτικές της καλλιέργειας/επιχείρησής τους</b> σε
        συνεργασία με την Αμερικανική Γεωργική Σχολή.
      </>
    ),
  },
  {
    image: VisualB,
    alt: 'Mentoring using phone app',
    width: 225,
    text: (
      <>
        <b>Μentoring και Ανάπτυξη Δεξιοτήτων</b>, ειδικά σχεδιασμένο από την ομάδα των 100mentors για την ανάπτυξη των
        οριζόντιων δεξιοτήτων των συμμετεχουσών, την προσωποποιημένη καθοδήγηση και την εμβάθυνση των γνώσεών τους, μέσω
        διαδραστικών εργαστηρίων και της εφαρμογής 100mentors.AI, η οποία συνδυάζει την Παραγωγική Τεχνητή Νοημοσύνη με
        την Ανθρώπινη Νοημοσύνη.
      </>
    ),
  },
];

interface BenefitsSectionProps {
  backgroundColor?: string;
  infoLink?: string;
}

export const AgroBenefitsSection: FC<BenefitsSectionProps> = ({ backgroundColor, infoLink }) => {
  return (
    <Section backgroundColor={backgroundColor}>
      <S.Headings>
        <S.Heading>Τι σας προσφέρει το πρόγραμμα Women in Agriculture</S.Heading>
        <S.SubHeading>Το πρόγραμμα, τρίμηνης διάρκειας, αποτελείται από δύο σκέλη:</S.SubHeading>
      </S.Headings>
      <S.Content>
        {benefits.map((benefit, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <S.BenefitContainer key={index}>
            <S.ImageContainer>
              <S.Image src={benefit.image} alt={benefit.alt} width={benefit.width} />
            </S.ImageContainer>
            <S.BulletItem>
              <S.OrderIndicator>{index + 1}</S.OrderIndicator>
              <S.BulletText>{benefit.text}</S.BulletText>
            </S.BulletItem>
          </S.BenefitContainer>
        ))}
      </S.Content>
      {infoLink && (
        <S.Footer>
          Αναλυτικότερες πληροφορίες για το πρόγραμμα, την ύλη, ενδεικτική λίστα διδασκόντων θα βρείτε{' '}
          <Link href={infoLink} targetBlank>
            εδώ
          </Link>
          .
        </S.Footer>
      )}
    </Section>
  );
};
